module.exports = __webpack_public_path__ + "img/vertical_3_4_5012.6c78eed9.png";